const orderConfig: Record<string, { name: string; shortName: string }> = {
  confirmed: {
    name: "Pedido Confirmado",
    shortName: "Confirmado",
  },
  denied: {
    name: "Pedido Cancelado pelo Estabelecimento",
    shortName: "Cancelado pelo Estabelecimento",
  },
  canceled: {
    name: "Pedido Cancelado",
    shortName: "Cancelado pelo Cliente",
  },
  ready: {
    name: "Seu Pedido está Pronto para a Retirada",
    shortName: "Pronto para Retirada",
  },
  delivering: {
    name: "Seu pedido Saiu para a Entrega",
    shortName: "Saiu para a Entrega",
  },
  concluded: {
    name: "Seu pedido foi Concluído",
    shortName: "Concluído",
  },
  integrated: {
    name: "Aguardando confirmação",
    shortName: "Integrado",
  },
};

export function getOrderStatus(status: string) {
  return orderConfig[status]?.name || "Aguardando confirmação";
}

export function getOrderStatusShort(status: string) {
  return orderConfig[status]?.shortName || "Integrado";
}

export type OrderStatusTone = "warning" | "info" | "success" | "error" | "default";

// Maps an order-viewer status code to a design-token semantic tone (used by
// OrderViewer's StatusBadge). This is a distinct status vocabulary from
// orderConfig above (waiting/in_preparation/finished/canceled, as returned by
// the order-viewer search/detail endpoints) rather than the
// confirmed/denied/ready/... vocabulary OrderPage's own status timeline uses.
export function getOrderStatusTone(status: string): OrderStatusTone {
  switch (status) {
    case "waiting":
      return "warning";
    case "in_preparation":
      return "info";
    case "finished":
      return "success";
    case "canceled":
      return "error";
    default:
      return "default";
  }
}

// Moved here from OrderViewer/components/OrdersListStep.tsx so OrderListItem
// (a sibling component) can use it without importing from OrdersListStep,
// which would create a circular import (OrdersListStep -> OrderListItem ->
// OrdersListStep). Money formatting lives in currency.helper (formatBRL).
export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
  });
